function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.0140635 2H3.5V0.5C3.5 0.367392 3.55268 0.240215 3.64645 0.146447C3.74021 0.0526784 3.86739 0 4 0H8C8.13261 0 8.25979 0.0526784 8.35355 0.146447C8.44732 0.240215 8.5 0.367392 8.5 0.5V2H11.9859L12 3.25H10.9688L10.3409 13.0625C10.325 13.3163 10.2131 13.5544 10.0279 13.7286C9.84262 13.9027 9.598 13.9998 9.34375 14H2.65625C2.40215 14 2.15758 13.9032 1.97225 13.7294C1.78692 13.5555 1.67472 13.3176 1.65844 13.0641L1.03125 3.25H0L0.0140635 2ZM8.5 12L8.78125 4H7.75L7.46875 12H8.5ZM5.5 12H6.5V4H5.5V12ZM4.75 2H7.25V1.125C7.25 1.09185 7.23683 1.06005 7.21339 1.03661C7.18995 1.01317 7.15815 1 7.125 1H4.875C4.84185 1 4.81005 1.01317 4.78661 1.03661C4.76317 1.06005 4.75 1.09185 4.75 1.125V2ZM3.5 12H4.53125L4.25 4H3.21875L3.5 12Z",
  fill: "#6C757D"
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.cc367285.svg";
export { ForwardRef as ReactComponent };